import axios from 'axios';

let keycloakToken = '';
const syncToken = (token) => {
    keycloakToken = token;
};
const initAxios = (allowedUrls = []) => {
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.interceptors.request.use((axiosRequestConfig) => {
        if (!axiosRequestConfig.headers) {
            axiosRequestConfig.headers = {};
        }
        if (keycloakToken &&
            (allowedUrls.length === 0 ||
                allowedUrls.some((url) => axiosRequestConfig.url && axiosRequestConfig.url.includes(url)))) {
            axiosRequestConfig.headers.authorization = `Bearer ${keycloakToken}`;
        }
        // axiosRequestConfig.headers['X-Request-ID'] = uuidv4();
        return axiosRequestConfig;
    }, (error) => {
        return Promise.reject(error);
    });
};
// Factory function to produce a function doing a POST to the given url, with the data passed as URL parameters.
function makePostWithParameters(url) {
    return async ({ csrfToken, ...params }) => {
        const result = await axios({
            method: 'post',
            url,
            params,
            headers: { 'X-CSRF-Token': csrfToken },
        });
        // just in case axios returns null/undefined
        if (result) {
            return result.data;
        }
        else {
            return Promise.reject(new Error(`Internal error while posting to ${url}`));
        }
    };
}
// Factory function to produce a function doing a POST to the given url, with the data passed in the body.
function makePostWithData(url) {
    return async ({ csrfToken, data }) => {
        const result = await axios({
            method: 'post',
            url,
            data,
            headers: { 'X-CSRF-Token': csrfToken },
        });
        // just in case axios returns null/undefined
        if (result) {
            return result.data;
        }
        else {
            return Promise.reject(new Error('Internal error while saving Adyen credit card'));
        }
    };
}
/**
 * Factory function to make a POST request to the given URL, include the given body and request params.
 * This function is introduced to replace the use of "makePostWithData" and "makePostWithParameters" since
 * they are using a "higher-order functions pattern" (function returns function) that makes the code harder
 * to understand.
 */
const axiosPost = (url, csrfToken, requestBody, requestParams) => {
    return axios({
        method: 'POST',
        url,
        data: requestBody,
        params: requestParams,
        headers: { 'X-CSRF-Token': csrfToken },
    });
};

export { axiosPost, initAxios, makePostWithData, makePostWithParameters, syncToken };
//# sourceMappingURL=api.js.map
